












request = require "superagent"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["post", "projectName"]
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		date: -> WP.date(this.post)
		excerpt: -> WP.excerpt(this.post)
		isNew: -> WP.isNew(this.post)
		displayTitle: -> 
			if !this.isEnglish then return this.post.title.rendered
			else
				if this.post.acf.title_en?&&this.post.acf.title_en then return this.post.acf.title_en else this.post.title.rendered
		decodedTitle: ->
			return this.displayTitle.replace(/&lt;/g,"<").replace(/&gt;/g,">")
	methods:
		renderText: (strJa, strEn) -> return if !this.isEnglish then strJa else strEn
		url: (post) ->
			if post.acf.url? and post.acf.url isnt "" then return "http://"+post.acf.url
			if post.acf.file? and post.acf.file isnt false then return post.acf.file.url
			return ""
		# escapeHTML: (text) ->
		# 	replacement = (ch) ->
		# 		characterReference = {
		# 			'&lt;': '<',
		# 			'&gt;': '>'
		# 		};
		# 		return characterReference[ ch ]
		# 	return text.replace( /["&'<>]/g, replacement )



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/news/postLink.vue